import PropTypes from 'prop-types';
import { Line } from 'rc-progress';

function ProgressBar(props) {
  const { colour, progress } = props;

  return (
    <div className="text-center">
      <Line percent={progress} strokeWidth={1} strokeColor={colour} strokeLinecap="round" />
      <span>{progress}%</span>
    </div>
  );
}

ProgressBar.propTypes = {
  colour: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
